<template>
    <simple-modal :show="type !== null" :title="`${type} Activity`" @close="closeForm">
        <div class="form">
            <div class="form-group">
                <label>Note / Activity Name</label>
                <div id="activity">
                    <el-autocomplete
                        class="inline-input w-100"
                        v-model="form.activity"
                        :fetch-suggestions="searchActivitySuggestions"
                        placeholder="Select or enter activity"
                    ></el-autocomplete>
                </div>

                <span class="invalid-feedback" :class="{'d-block': form.errors.has('activity')}"
                      v-show="form.errors.has('activity')">
                    {{ form.errors.get("activity") }}
                </span>
            </div>

            <div class="form-group">
                <label>Detail</label>
                <textarea
                    v-model="form.notes"
                    class="form-control"
                    type="text"
                    style="height:80px"
                    id="notes"
                    :class="{'is-invalid': form.errors.has('notes')}">
                                </textarea>

                <span class="invalid-feedback" v-show="form.errors.has('notes')">
                    {{ form.errors.get("notes") }}
                </span>
            </div>
        </div>

        <div class="flex flex-col md:flex-row md:justify-between md:items-center">
            <button type="button" class="btn btn-default waves-effect" data-dismiss="modal"
                    @click.prevent="closeForm()"
                    :disabled="form.busy">
                Cancel
            </button>
            <button class="btn btn-success waves-effect waves-light"
                    @click.prevent="createOrEditActivity"
                    :disabled="form.busy">
                {{ type }}
            </button>
        </div>
    </simple-modal>
</template>

<script>
import ActivitySuggestions from "../../../mixins/activity-suggestion-list";

export default {
    name: "ActivityEditCreateForm",

    mixins: [ActivitySuggestions],

    props: {
        ticket: {
            required: true,
            type: Object,
            description: "Ticket to create activity on"
        },
        activity: {
            required: false,
            type: Object,
            description: "The activity to edit"
        },
        type: {
            type: String,
            required: true,
            description: "The type of execution. Create or Edit"
        },
    },

    data () {
        return {
            mutableTicket: this.ticket,
            form: new AppForm({}),
        };
    },

    mounted () {
        this.resetForm();
    },

    methods: {
        createOrEditActivity () {
            if (this.type === "Create") {
                this.createActivity();
            } else if (this.type === "Edit") {
                this.editActivity();
            }
        },

        createActivity () {
            App.post("/activities/" + this.mutableTicket.id + "/create", this.form)
            .then(response => {
                this.$emit("activity-added", response);
                this.resetForm();
                this.closeForm();
            }).catch((error) => {
                toastr.error("Activity Could Not Be Created. Error: " + error.message);
            });
        },

        editActivity () {
            App.patch("/activities/" + this.activity.id + "/update", this.form)
            .then(response => {
                this.$emit("activity-edited", response);
                this.resetForm();
                this.closeForm();
            }).catch((error) => {
                toastr.error("Activity Could Not Be Updated. Error: " + error.message);
            });
        },

        resetForm () {
            this.form = new AppForm({
                activity: this.activity ? this.activity.activity : "",
                notes: this.activity ? this.activity.notes : "",
            });
        },

        closeForm () {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>

</style>
